import { ReactNode } from 'react';
import { Box, Dialog, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { IconX } from '@tabler/icons';
import { DS } from './ds';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  icon: ReactNode;
  title: string;
  subtitle?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg';
  children: ReactNode;
}

const FormDialog = ({ open, onClose, icon, title, subtitle, maxWidth = 'sm', children }: FormDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth={maxWidth}
    PaperProps={{ sx: { borderRadius: 3, boxShadow: '0 12px 40px rgba(0,0,0,0.18)', overflow: 'hidden' } }}
  >
    <DialogTitle
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${DS.border}`,
        py: 2.25,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
            borderRadius: 2.5,
            bgcolor: DS.blueLightBg,
            color: DS.blue,
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography fontWeight={700} fontSize={18} color={DS.textPrimary} lineHeight={1.25}>
            {title}
          </Typography>
          {subtitle && (
            <Typography fontSize={13} color={DS.textSecondary} mt={0.25}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>
      <IconButton onClick={onClose} size="small" sx={{ color: DS.textSecondary, '&:hover': { bgcolor: DS.grayMid } }}>
        <IconX size={18} />
      </IconButton>
    </DialogTitle>

    {children}
  </Dialog>
);

export default FormDialog;
